import { AnimatedList } from './AnimatedList';
import NotificationCard from './NotificationCard';

const ShopifyNotifications = () => {
	return (
		<div className="relative flex h-[400px] w-full max-w-[64rem] flex-col overflow-hidden md:h-[420px] lg:h-[450px]">
			<AnimatedList>
				{Array.from({ length: 7 }, (_, idx) => (
					<NotificationCard key={idx} />
				))}
			</AnimatedList>
		</div>
	);
};

export default ShopifyNotifications;
